var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-view-closer"},[_c('div',{staticClass:"content-details"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.content.title))]),_c('div',{staticClass:"description"},_vm._l((_vm.tags),function(tag,id){return _c('span',{key:id},[_vm._v(_vm._s(tag))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }